module.exports = __webpack_public_path__ + "media/components/assets/images/makeyourdream/image5-2632627d3f209a306b5ed1df7b775667.png";